<template>
  <div>
    <!-- Form -->
    <a-modal
      :width="
        this.settings['isMobileView']
          ? 480
          : this.settings['isTabletView']
          ? 720
          : 1080
      "
      v-model="visible"
      title="Edit Exam"
      onOk="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSave"
          >Save Exam</a-button
        >
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <div class="row">
            <!-- Select Session -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Session">
                <a-select
                  v-decorator="[
                    'session_id',
                    {
                      rules: [
                        { required: true, message: 'Please select a session!!' }
                      ],
                      initialValue: currentSession ? currentSession.id : ''
                    }
                  ]"
                  placeholder="Select session"
                  :disabled="true"
                >
                  <a-select-option
                    v-for="schoolSession in schoolSessions"
                    :value="schoolSession.id"
                    :key="schoolSession.id"
                  >
                    {{ schoolSession.name }}
                    <small class="text-primary ml-3">{{
                      currentSession.id === schoolSession.id ? "Current" : ""
                    }}</small>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Select Class -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    v-decorator="[
                      'class_id',
                      {
                        rules: [
                          { required: true, message: 'Please select a class!!' }
                        ],
                        initialValue: undefined
                      }
                    ]"
                    placeholder="Select class"
                    @change="handleClassSelect"
                  >
                    <a-select-option :value="undefined">
                      Select class
                    </a-select-option>
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Select Section -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Sections">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    v-decorator="[
                      'section_id',
                      {
                        initialValue: null
                      }
                    ]"
                    :disabled="!form.getFieldValue(`class_id`)"
                  >
                    <a-select-option :value='null'>
                      All sections
                    </a-select-option>
                    <template v-for="section in sections">
                      <a-select-option :value="section.id" :key="section.id">
                        {{ section.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <!-- Name -->
            <div class="col-md-12 mb-2">
              <a-form-item label="Name">
                <a-input
                  placeholder="Name"
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input exam instruction name!'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </div>
            <!-- Description -->
            <div class="col-md-12 mb-2">
              <a-form-item label="Description">
                <a-textarea
                  placeholder="Description"
                  :autosize="{ minRows: 2 }"
                  v-decorator="[
                    'description',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input a description!'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </div>
            <!-- Subjects -->
            <div class="col-md-12 mb-2">
              <div
                style="border: solid 1px; border-radius: 3px;border-color: #f1f1f1!important;padding: 10px;padding-top: 5px"
              >
                <template>
                  <a-form-item>
                    <span style="color: #161537; font-weight: bold"
                      >Select exam subjects: &nbsp;&nbsp;&nbsp;
                    </span>
                    <a-checkbox
                      v-decorator="[
                        'cut_off_stat',
                        {
                          valuePropName: 'checked',
                          initialValue: false
                        }
                      ]"
                      :disabled="!form.getFieldValue('class_id')"
                    >
                    </a-checkbox>
                    <span style="color: #161537; font-weight: bold"
                      >Enable cut-off mark</span
                    >
                  </a-form-item>
                </template>
                <div class="col-md-12">
                  <div
                    class="table-responsive"
                    v-if="classSubjects.length !== 0"
                  >
                    <div
                      class="col-md-6"
                      v-for="(subject, index) in classSubjects"
                      :key="index"
                      style="display: inline-block;"
                    >
                      <div class="col-md-12" style="display: flex">
                        <!-- selected checkbox -->
                        <div class="column col-md-4 mb-2 text-left">
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][selected]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false
                                }
                              ]"
                            >
                            </a-checkbox>
                            <span style="color: #161537; font-weight: bold">{{
                              subject.subject.name
                            }}</span>
                          </a-form-item>
                        </div>
                        <!-- subject  -->
                        <div class="column text-left" v-show="false">
                          <a-form-item class="d-none">
                            <a-input
                              v-decorator="[
                                `subjects[${subject.subject_id}][subject_id]`,
                                {
                                  rules: [
                                    { required: true, message: 'Required' }
                                  ],
                                  initialValue: subject.subject_id
                                }
                              ]"
                            />
                          </a-form-item>
                        </div>
                        <!-- cut off mark field -->
                        <div class="column col-md-4 mb-2">
                          <a-form-item>
                            <a-input-number
                              placeholder=""
                              v-decorator="[
                                `subjects[${subject.subject_id}][cut_off_mark]`,
                                {
                                  rules: [
                                    { required: checked && form.getFieldValue(`subjects[${subject.subject_id}][selected]`),
                                      message: 'Required' }
                                  ],
                                  initialValue: null
                                }
                              ]"
                              :min="0"
                              style="width: 100%"
                            />
                          </a-form-item>
                        </div>
                        <!-- Subject serial No -->
                        <div class="column col-md-4 mb-2">
                          <a-form-item>
                            <a-input-number
                              placeholder="Serial No."
                              v-decorator="[
                                `subjects[${subject.subject_id}][serialNo]`,
                                {
                                  rules: [
                                    { required: form.getFieldValue(`subjects[${subject.subject_id}][selected]`),
                                      message: 'Please fill a serial No.!' }
                                  ],
                                  initialValue: null
                                }
                              ]"
                              :min="0"
                              style="width: 100%"
                            />
                          </a-form-item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <span class="text-danger">No class selected !!</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Select Instruction -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Exam Instruction">
                <a-spin :spinning="instructionSpinning">
                  <a-select
                    v-decorator="[
                      'instruction_id',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please select an instruction!!'
                          }
                        ],
                        initialValue: undefined
                      }
                    ]"
                    placeholder="Select instruction"
                    :disabled="!form.getFieldValue('class_id')"
                  >
                    <a-select-option :value="undefined">
                      Select instruction
                    </a-select-option>
                    <template v-for="examInstruction in examInstructions">
                      <a-select-option
                        :value="examInstruction.id"
                        :key="examInstruction.id"
                      >
                        {{ examInstruction.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Select Exam Schedule Type -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Schedule Type">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    v-decorator="[
                      'schedule_type',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Select schedule type!!'
                          }
                        ],
                        initialValue: 0
                      }
                    ]"
                    :disabled= true
                     @change="handleScheduleTypeChange"
                  >
                    <a-select-option :value='undefined'>
                      Select schedule type
                    </a-select-option>
                    <template v-for="schedule in scheduleType">
                      <a-select-option :value="schedule.value" :key="schedule.id">
                        {{ schedule.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <!-- Date -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Exam Date">
                <a-date-picker
                  :disabledDate="disabledDate"
                  v-decorator="[
                    `date`,
                    {
                      rules: [
                        { required: true, message: 'Please input an exam date' }
                      ]
                    }
                  ]"
                  :format="dateFormat"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Start time -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Start time">
                <a-time-picker
                  v-decorator="[
                    `start_time`,
                    {
                      rules: [
                        { required: true, message: 'Please input a start time' }
                      ]
                    }
                  ]"
                  use12Hours
                  :format="timeFormat"
                  style="width:100%;"
                >
                </a-time-picker>
              </a-form-item>
            </div>
            <!-- end time -->

            <div class="col-md-2 mb-2" v-if="this.expireDateTimeShow === false">
              <a-form-item label="End time">
                <a-time-picker
                  v-decorator="[
                    `end_time`,
                    {
                      rules: [
                        { required: true, message: 'Please input an end time' }
                      ]
                    }
                  ]"
                  use12Hours
                  :format="timeFormat"
                  style="width:100%;"
                >
                </a-time-picker>
              </a-form-item>
            </div>
            <!-- Duration -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Duration (mins)">
                <a-input-number
                  v-decorator="[
                    `duration`,
                    {
                      rules: [
                        { required: true, message: 'Please input a duration' }
                      ]
                    }
                  ]"
                  :min="1"
                  :max="560"
                  placeholder="Duration"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Expire date -->
            <div class="col-md-2 mb-2" v-if="this.expireDateTimeShow === true">
              <a-form-item label="Expire Date">
                <a-date-picker
                  :disabledDate="disabledDate"
                  v-decorator="[
                    `expire_date`,
                    {
                      rules: [
                        { required: true, message: 'Please input an expire date' }
                      ]
                    }
                  ]"
                  :format="dateFormat"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Expire time -->
            <div class="col-md-2 mb-2" v-if="this.expireDateTimeShow === true">
              <a-form-item label="Expire time">
                <a-time-picker
                  v-decorator="[
                    `expire_time`,
                    {
                      rules: [
                        { required: true, message: 'Please input an expire time' }
                      ]
                    }
                  ]"
                  use12Hours
                  :format="timeFormat"
                  style="width:100%;"
                >
                </a-time-picker>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <!-- Select exam type -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Exam type">
                <a-select
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        { required: true, message: 'Please select a type!!' }
                      ],
                      initialValue: undefined
                    }
                  ]"
                  placeholder="Select exam type"
                >
                  <a-select-option
                    v-for="(exam, index) in examTypes"
                    :key="index"
                    :value="exam.id"
                    >{{ exam.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </div>
            <!-- Full mark -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Full Mark">
                <a-input-number
                  v-decorator="[
                    `full_mark`,
                    {
                      rules: [
                        { required: true, message: 'Please input full mark' }
                      ]
                    }
                  ]"
                  :min="1"
                  :max="10000"
                  placeholder="Full mark"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Pass mark -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Pass Mark">
                <a-input-number
                  v-decorator="[
                    `pass_mark`,
                    {
                      rules: [
                        { required: false, message: 'Please input pass mark' }
                      ]
                    }
                  ]"
                  :min="1"
                  :max="10000"
                  placeholder="Pass mark"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Questionwise mark -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Questionwise Mark">
                <a-input-number
                  v-decorator="[
                    `questionwise_mark`,
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input Questionwise mark'
                        }
                      ]
                    }
                  ]"
                  :min="1"
                  :max="10000"
                  placeholder="Questionwise mark"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Negative mark -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Negative Mark">
                <a-input-number
                  v-decorator="[
                    `negative_mark`,
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input Negative mark'
                        }
                      ]
                    }
                  ]"
                  :min="1"
                  :max="10000"
                  placeholder="Negative mark"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Shuffle -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Shuffle">
                <a-select
                  v-decorator="[
                    'shuffle',
                    { rules: [{ required: false }], initialValue: 0 }
                  ]"
                >
                  <a-select-option :value="0">No</a-select-option>
                  <a-select-option :value="1">Yes</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Select after exam option -->
            <div class="col-md-3 mb-2">
              <a-form-item label="After exam">
                <a-select
                  v-decorator="[
                    'after_exam',
                    {
                      rules: [
                        { required: true, message: 'Please select an option!!' }
                      ],
                      initialValue: 1
                    }
                  ]"
                >
                  <a-select-option
                    v-for="option in afterOnlineExamOptions"
                    :key="option.value"
                    :value="option.value"
                    >{{ option.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </div>
            <!-- Category wise result -->
            <div class="col-md-3 mb-2 d-none">
              <a-form-item label="Category-wise Result">
                <a-select
                  v-decorator="[
                    'category_result',
                    { rules: [{ required: false }], initialValue: 0 }
                  ]"
                >
                  <a-select-option :value="0">No</a-select-option>
                  <a-select-option :value="1">Yes</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Select exam status -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Exam status">
                <a-select
                  v-decorator="[
                    'status',
                    {
                      rules: [
                        { required: true, message: 'Please select an option!!' }
                      ],
                      initialValue: 1
                    }
                  ]"
                >
                  <a-select-option
                    v-for="status in onlineExamStatus"
                    :key="status.value"
                    :value="status.value"
                    >{{ status.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </div>
            <!-- Publish Date -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Publish Date">
                <a-date-picker
                  :disabledDate="disabledDate"
                  v-decorator="[
                    `publish_date`,
                    {
                      rules: [
                        { required: true, message: 'Please input an exam date' }
                      ]
                    }
                  ]"
                  :format="dateFormat"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <!-- Publish time -->
            <div class="col-md-2 mb-2">
              <a-form-item label="Publish time">
                <a-time-picker
                  v-decorator="[
                    `publish_time`,
                    {
                      rules: [
                        { required: true, message: 'Please input a start time' }
                      ]
                    }
                  ]"
                  use12Hours
                  :format="timeFormat"
                  style="width:100%;"
                >
                </a-time-picker>
              </a-form-item>
            </div>
          </div> <!-- end row -->
          <!-- Exam declaration Row -->
          <div class="row">
            <div class="col-md-2 mb-2">
              <a-form-item label="Declare Date">
                <a-date-picker :disabledDate="disabledDate" ref="declaredate"
                  v-decorator="[
                    `declare_date`,
                    {
                      rules: [
                        { required: false }
                      ],
                      initialValue: undefined
                    }
                  ]"
                  :format="dateFormat"
                  style="width:100%;"
                />
              </a-form-item>
            </div>
            <div class="col-md-2 mb-2">
                <a-form-item label="Declare time">
                  <a-time-picker ref="declaretime"
                    v-decorator="[
                      `declare_time`,
                      {
                        rules: [
                          { required:false }
                        ],
                        initialValue: undefined
                      }
                    ]"
                    use12Hours
                    :format="timeFormat"
                    style="width:100%;"
                  >
                  </a-time-picker>
                </a-form-item>
              </div>
          </div>
          <!-- End Exam declaration Row -->
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {
  onlineExamTypes,
  afterOnlineExamOptions,
  onlineExamStatus,
  scheduleType,
} from '@/services/globaldata'
import {
  makeOnlineExamData,
  makeClassSectionExamSubjectData,
} from './editFields'
import { compareDate } from '../helper'
import { mapValues, find } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'OnlineExamForm',

  mounted: function() {
    this.getOnlineExamType()
    this.getExamInstructions()
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
    this.$eventBus.$on('openOnlineExamEditFormModal', this.showModal)
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      onlineExamTypes,
      scheduleType,
      afterOnlineExamOptions,
      onlineExamStatus,
      subjectIds: [],
      loading: false,
      visible: false,
      spinning: false,
      examId: null,
      examInstructions: [],
      instructionSpinning: false,
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      classSubjects: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
      subjectSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'h:mm a',
      editorData: '',
      examloading: false,
      examTypes: [],
      checked: false,
      subjectCheck: false,
      selectedSubjects: [],
      classID: null,
      expireDateTimeShow: false,
    }
  },
  computed: {
    ...mapState(['settings']),
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    subjectOptions: function() {
      const subjects = []
      this.classSubjects.map(function(element) {
        subjects.push({
          label: `${element.subject.name} (${element.subject.abbreviation})`,
          value: element.subject.id,
          // slNo: element.serialNo,
        })
      })
      return subjects
    },
  },
  watch: {
    expireDateTimeShow: function(val) {
      return val
    },
    classSubjects: function(val) {
      if (val.length > 0) {
        this.$nextTick(() => {
          const subjectFieldsData = makeClassSectionExamSubjectData(
            this.classSectionExamData.exam_subjects
          )
          // console.log('checked', subjectFieldsData.checked)
          let enableStat = subjectFieldsData.checked
          if (enableStat === true) {
            this.checked = true
          }
          this.form.setFieldsValue(subjectFieldsData)
        })
      }
    },
    checked: function(val) {
      return val
    },
    selectedSubjects: function(val) {
      return val
    },
    currentSession: function(val) {
      this.selectedSession = val.id
    },
    isAllSections: function(val) {
      if (val) {
        this.form.setFieldsValue({ sections: [0] })
      }
    },
  },
  methods: {
    moment,
    handleScheduleTypeChange(e) {
      if (e === 1) {
        this.expireDateTimeShow = true
      } else {
        this.expireDateTimeShow = false
      }
    },
    toggleSubjectSelect(e) {
      this.selectedSubjects = []
      if (e.length !== 0) {
        e.forEach((value, index) => {
          let data = {
            subject_id: parseInt(value),
            cut_off_mark: null,
          }
          this.selectedSubjects.push(data)
        })
      } else {
        this.selectedSubjects = []
      }
    },
    checkCutOff(e) {
      this.checked = e.target.checked
      this.selectedSubjects = []
    },
    getOnlineExamType() {
      this.examloading = true
      this.$http.get('/api/online-exam/examtype/all').then(({ data }) => {
        this.examloading = false
        this.examTypes = data.data
        this.meta = data.meta
      })
    },
    handleEditorChange(value) {
      this.editorData = value
    },
    // show model
    showModal: function(examId) {
      this.visible = true

      if (examId) {
        this.examId = examId
        this.subjectIds = []
        this.loading = true
        this.spinning = true
        this.$http.get('/api/online-exam/' + examId).then(({ data }) => {
          this.classSectionExamData = data.data
          const editData = makeOnlineExamData(data.data)
          // const subjectData = makeClassSectionExamSubjectData(data.data.exam_subjects)
          const fieldsData = mapValues({ ...editData }, function(value) {
            return value
          })
          this.subjectIds = data.data.exam_subjects.map(function(examSubject) {
            return examSubject.subject_id
          })
          this.getClassSections(data.data.class_id)
          this.getClassSubjects(data.data.class_id)
          this.form.setFieldsValue(fieldsData)
          this.editorData = data.data.description
          this.spinning = false
          this.loading = false
        })
      } else {
        this.examId = null
        this.editorData = ''
        this.form.resetFields()
      }
    },
    getExamInstructions() {
      this.instructionSpinning = true
      this.$http
        .get('/api/online-exam/instruction/all', {
          params: {
            limit: 15,
          },
        })
        .then(({ data }) => {
          this.instructionSpinning = false
          this.examInstructions = data.data
        })
    },
    getClassSubjects(classId) {
      this.$http
        .get(`/api/subject/class/${classId}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.all
          this.subjectSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.subjectOptions = []
      this.classSubjects = []
      this.form.resetFields(['sections'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
        this.getClassSubjects(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    handleSave: function(e) {
      // Update
      if (this.examId) {
        this.form.validateFields((err, values) => {
          if (!err) {
            const formData = this.makeFormData(values)
            if (formData.declare_on !== null) {
              let sd = `${formData.date} ${formData.end_time}`
              let startdatetime = moment(sd)
              // console.log(compareDate(moment(formData.declare_on), startdatetime))
              if (compareDate(moment(formData.declare_on), startdatetime) === 'lesser') {
                this.$notification['error']({
                  message: 'Declare date error',
                  description: `Declare date shouldn't be less than ${sd}.`,
                })
                return
              }
            }

            this.$confirm({
              title: `Are you sure you want to update ${values.name}?`,
              content: `Click on the OK button to update the details!`,
              onOk: () => {
                this.loading = true
                // const formData = this.makeFormData(values)
                let getSubjects = formData.subjects
                formData.subjects = []
                if (this.selectedSubjects.length === 0) {
                  getSubjects.forEach((value, index) => {
                    if (value.selected === true) {
                      let data = {
                        subject_id: parseInt(value.subject_id),
                        cut_off_mark: value.cut_off_mark,
                        serialNo: value.serialNo,
                      }
                      formData.subjects.push(data)
                    }
                  })
                }
                // console.debug('checking form data...')
                // console.log(this.form.getField)
                // console.log(formData)
                // console.log('formdata', formData)

                this.$http
                  .patch('/api/online-exam/' + this.examId, formData)
                  .then(() => {
                    this.$emit('saved')
                    this.loading = false
                    this.visible = false
                    this.$notification['success']({
                      message: 'Successfully edited',
                      description: 'Exam instruction updated successfully!',
                    })
                  })
                  .catch(error => {
                    this.loading = false
                    this.$neoNotify.error(error)
                  })
              },
              onCancel: () => {
                this.loading = false
                this.examInstructionId = null
                this.editorData = ''
              },
            })
          }
        })
      } else {
        // Create
        this.form.validateFields((err, values) => {
          if (!err) {
            const formData = this.makeFormData(values)
            let getSubjects = formData.subjects
            formData.subjects = []
            if (this.selectedSubjects.length === 0) {
              getSubjects.forEach((value, index) => {
                if (value.selected === true) {
                  let data = {
                    subject_id: parseInt(value.subject_id),
                    cut_off_mark: value.cut_off_mark,
                    serialNo: value.serialNo,
                  }
                  formData.subjects.push(data)
                }
              })
            }
            // else {
            //   JSON.parse(JSON.stringify(this.selectedSubjects)).forEach((value, index) => {
            //     formData.subjects.push(value)
            //   })
            // }
            this.$confirm({
              title: `Are you sure?`,
              content: `Click on the OK button to add the exam!`,
              onOk: () => {
                this.loading = true
                this.$http
                  .post('/api/online-exam/create', formData)
                  .then(data => {
                    this.$emit('saved')
                    this.loading = false
                    this.visible = false
                    this.$notification['success']({
                      message: 'Successfully saved',
                      description: 'Exam saved successfully!',
                    })
                    this.examInstructionId = null
                    this.editorData = ''
                    this.$router.push({
                      name: 'onlineexamquestions',
                      params: { id: data.data.id },
                    })
                  })
                  .catch(error => {
                    this.loading = false
                    this.$neoNotify.error(error)
                  })
              },
              onCancel: () => {
                this.loading = false
                this.examInstructionId = null
                this.editorData = ''
              },
            })
          }
        })
      }
    },
    handleCancel(e) {
      this.visible = false
      this.examInstructionId = null
      this.editorData = ''
      this.classSubjects = []
      this.form.resetFields()
    },
    makeFormData(values) {
      values.date = moment(values.date).format('YYYY-MM-DD')
      values.start_time = moment(values.start_time, 'hh:mm a').format(
        'HH:mm:ss'
      )
      values.end_time = moment(values.end_time, 'hh:mm a').format('HH:mm:ss')

      let publishDate = moment(values.publish_date).format('YYYY-MM-DD')
      let publishTime = moment(values.publish_time, 'hh:mm a').format(
        'HH:mm:ss'
      )

      // adding declare time
      let declaredate = moment(values.declare_date).format('YYYY-MM-DD')
      let declaretime = moment(values.declare_time, 'hh:mm a').format('HH:mm:ss')
      values.declare_on = `${declaredate} ${declaretime}`
      values.publish_on = `${publishDate} ${publishTime}`
      if (declaredate === 'Invalid date' || declaretime === 'Invalid date') {
        values.declare_on = null
      } else {
        values.declare_on = `${declaredate} ${declaretime}`
      }

      delete values.declare_date
      delete values.declare_time
      delete values.publish_date
      delete values.publish_time
      return values
    },
  },
}
</script>
<style>
#horizontalShow,
#horiontalShowChild {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
